/*
  ThemeColors.js
  Betterment Labs 
  Created by Charles Major on 02/01/18. 
  Copyright © 2018 Betterment Labs, LLC. All rights reserved.

  Use :
*/

import ColorPalette from './ColorPalette';

const ThemeColors = {
    background: ColorPalette.White,
    bodyText: ColorPalette.DarkerPurpler,
    title: ColorPalette.DarkerPurpler,
    secondary: ColorPalette.Teal,
    tertiary: ColorPalette.DarkBlue,
    highlight: ColorPalette.BrighterYellow,
    detailText: ColorPalette.DarkGray,
    quarternary: ColorPalette.SnowWhite,
    navColor: ColorPalette.Teal,
    buttonGray: ColorPalette.LightGray,
    black: ColorPalette.Black
}

export default ThemeColors;


// WEBPACK FOOTER //
// ./src/interface/AppStyles/ThemeColors.js